export default {
  methods: {
    getAddressComponentsMB(address_components) {
      const address = {};
      if (address_components && address_components.context.length > 0) {
        if (address_components.id.includes('address')) {
          let streetText = address_components.text || '';
          let number = address_components.address || '';
          address.street = `${streetText} ${number}`;
        }

        const countryObj = address_components.context.find((cmp) => {
          return cmp.id.includes('country');
        });
        const countryCode = countryObj ? countryObj.short_code : null;

        for (let i = 0; i < address_components.context.length; i++) {
          let component = address_components.context[i];
          let name = component['text'];
          let types = component['id'];

          if (types.includes('postcode')) {
            address.postalCode = name;
          } else if (types.includes('country')) {
            address.country = name;
          } else if (types.includes('place')) {
            address.city = name;
          } else if (
            types.includes('region') &&
            countryCode === 'at' &&
            address.postalCode &&
            address.postalCode[0] === '1'
          ) {
            address.city = name;
          }
        }
      }

      return address;
    },
  },
};
